export const ACCOUNT_NOT_FOUND_MSG = 'Account information not available, Please contact support.';
export const GA_MEASUREMENT_ID = "G-N0343K7EBT"

export const dateFormats = [
  {
    label: "YYYY-MM-DD",
    format: "YYYY-MM-DD",
    regex: /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/,
  },
  {
    label: "DD-MM-YYYY",
    format: "DD-MM-YYYY",
    regex: /^(0[1-9]|[12]\d|3[01])-(0[1-9]|1[0-2])-\d{4}$/,
  },
  {
    label: "MM-DD-YYYY",
    format: "MM-DD-YYYY",
    regex: /^(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])-\d{4}$/,
  },
  {
    label: "YYYY/MM/DD",
    format: "YYYY/MM/DD",
    regex: /^\d{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])$/,
  },
  {
    label: "DD/MM/YYYY",
    format: "DD/MM/YYYY",
    regex: /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
  },
  {
    label: "MM/DD/YYYY",
    format: "MM/DD/YYYY",
    regex: /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/,
  },
  {
    label: "DD Mon YYYY",
    format: "DD Mon YYYY",
    regex: /^(0[1-9]|[12]\d|3[01]) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) \d{4}$/,
  },
  {
    label: "Mon DD, YYYY",
    format: "Mon DD, YYYY",
    regex: /^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (0[1-9]|[12]\d|3[01]), \d{4}$/,
  },
  {
    label: "YYYY.MM.DD",
    format: "YYYY.MM.DD",
    regex: /^\d{4}\.(0[1-9]|1[0-2])\.(0[1-9]|[12]\d|3[01])$/,
  },
];


export const allowedTags = [
  "b", "i", "u", "strong", "em", "br",
  "ul", "ol", "li",
  "h1", "h2", "h3", "h4", "h5", "h6",
  "p", "a"
];

export const allowedAttr = [
  'href', 'rel', 'target'
]

export const gigTypes = [
        {
            "id": 5,
            "gig_category_id": 5,
            "name": "Brand Promotion",
            "slug": "brand_promotion",
            "created_at": "2025-03-12T11:34:07.088818Z",
            "updated_at": "2025-03-12T11:34:07.088818Z",
            "flag": true,
            "object_name": "Brand",
            "class": "BrandPromotion",
            "has_value": false,
            "has_gigs": false,
            "has_options": false,
            "properties": [
                {
                    "id": 19,
                    "gig_type_id": 5,
                    "label": "URL",
                    "key": "url",
                    "type": "url",
                    "sort_order": 1,
                    "mandatory": false,
                    "created_at": "2025-03-12T11:48:01.081249Z",
                    "updated_at": "2025-03-12T11:48:01.081249Z",
                    "flag": true
                }
            ]
        },
        {
            "id": 2,
            "gig_category_id": 2,
            "name": "Store Visit",
            "slug": "store_visit",
            "created_at": "2025-03-12T11:34:07.088818Z",
            "updated_at": "2025-03-12T11:34:07.088818Z",
            "flag": true,
            "object_name": "Store",
            "class": "StoreVisit",
            "has_value": false,
            "has_gigs": true,
            "has_options": false,
            "properties": [
                {
                    "id": 7,
                    "gig_type_id": 2,
                    "label": "Business Hours",
                    "key": "business_hours",
                    "type": "string",
                    "sort_order": 4,
                    "mandatory": false,
                    "created_at": "2025-03-12T11:48:01.081249Z",
                    "updated_at": "2025-03-12T11:48:01.081249Z",
                    "flag": true
                },
                {
                    "id": 9,
                    "gig_type_id": 2,
                    "label": "Contact Name",
                    "key": "contact_name",
                    "type": "string",
                    "sort_order": 6,
                    "mandatory": false,
                    "created_at": "2025-03-12T11:48:01.081249Z",
                    "updated_at": "2025-03-12T11:48:01.081249Z",
                    "flag": true
                },
                {
                    "id": 23,
                    "gig_type_id": 2,
                    "label": "Address",
                    "key": "address",
                    "type": "address",
                    "sort_order": 3,
                    "mandatory": true,
                    "created_at": "2025-03-12T11:48:01.081249Z",
                    "updated_at": "2025-03-12T11:48:01.081249Z",
                    "flag": true
                },
                {
                    "id": 8,
                    "gig_type_id": 2,
                    "label": "Contact Number",
                    "key": "phone",
                    "type": "tel",
                    "sort_order": 5,
                    "mandatory": false,
                    "created_at": "2025-03-12T11:48:01.081249Z",
                    "updated_at": "2025-03-12T11:48:01.081249Z",
                    "flag": true
                }
            ]
        },
        {
            "id": 3,
            "gig_category_id": 3,
            "name": "Repost",
            "slug": "repost",
            "created_at": "2025-03-12T11:34:07.088818Z",
            "updated_at": "2025-03-12T11:34:07.088818Z",
            "flag": true,
            "object_name": "Post",
            "class": "Repost",
            "has_value": false,
            "has_gigs": true,
            "has_options": false,
            "properties": [
                {
                    "id": 18,
                    "gig_type_id": 3,
                    "label": "Permalink",
                    "key": "permalink",
                    "type": "permalink",
                    "sort_order": 1,
                    "mandatory": true,
                    "created_at": "2025-03-12T11:48:01.081249Z",
                    "updated_at": "2025-03-12T11:48:01.081249Z",
                    "flag": true
                }
            ]
        },
        {
            "id": 1,
            "gig_category_id": 1,
            "name": "Product Review",
            "slug": "product_review",
            "created_at": "2025-03-12T11:34:07.088818Z",
            "updated_at": "2025-03-12T11:34:07.088818Z",
            "flag": true,
            "object_name": "Product",
            "class": "ProductReview",
            "has_value": true,
            "has_gigs": true,
            "has_options": true,
            "properties": [
                {
                    "id": 1,
                    "gig_type_id": 1,
                    "label": "URL",
                    "key": "url",
                    "type": "url",
                    "sort_order": 1,
                    "mandatory": true,
                    "created_at": "2025-03-12T11:48:01.081249Z",
                    "updated_at": "2025-03-12T11:48:01.081249Z",
                    "flag": true
                }
            ]
        }
    ]

  export const CREATOR_APP_URL = process.env.REACT_APP_ENV === 'production' ? 'https://app.influns.com' : 'https://app.influns.com';

  export const platforms = {
    ig: { id: 'ig', name: 'Instagram' },
    yt: { id: 'yt', name: 'YouTube' },
}

export const LOGO_CDN_URL = "https://d3esz4e2jyp077.cloudfront.net/app/logo/influns-logo.png";